import { identity, mapValues, pickBy, trim } from 'lodash';

// Re-export request and useRequest from http.tsx for backwards compatibility
export { request, silentRequest, useRequest } from './http';

type Params = {
  [key: string]: any;
};

export function trimParams(params: Params) {
  return mapValues(params, trim);
}

export function filterEmptyParams(params: Params) {
  return pickBy(params, identity);
}

export function filterNullUndefinedEmptyParams(params: Params) {
  return pickBy(params, (value) => {
    return value !== null && value !== undefined && value !== '';
  });
}

export function trimAndFilterEmptyParams(params: Params) {
  const tempParams = trimParams(params);
  return filterEmptyParams(tempParams);
}
